import { useCallback, useContext, type ReactNode } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

import Clickable from 'components/Common/Clickable'
import Image from 'components/Common/Image'
import Modal from 'LuxKit/Modal/Modal'
import Group from 'components/utils/Group'
import ModalContext from 'contexts/ModalContext'

const CardRoot = styled(Clickable)`
  width: ${rem(200)};
  border-radius: ${props => props.theme.borderRadius.S};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  box-shadow: ${props => props.theme.shadow.flat.small};
  overflow: hidden;
  text-align: start;
  display: flex;
  flex-direction: column;
`

const ImageWrapper = styled.div`
  position: relative;
  height: ${rem(140)};
`

const CardImage = styled(Image)`
  position: absolute;
  inset: 0;
`

const ContentArea = styled.div`
  padding: ${rem(12)};
`

interface Props {
  imageId: string
  imageAlt: string
  modalTitle: string
  modalContent: ReactNode
  children: ReactNode
}

function CruiseItineraryAttractionCard({
  imageId,
  imageAlt,
  modalTitle,
  modalContent,
  children,
}: Props) {
  const showModal = useContext(ModalContext)

  const handleOpen = useCallback(() => {
    showModal(
      <Modal title={modalTitle}>
        <Group direction="vertical" gap={16}>
          <Image id={imageId} alt={imageAlt} fit="center" />
          {modalContent}
        </Group>
      </Modal>,
    )
  }, [showModal, imageId, imageAlt, modalTitle, modalContent])

  return (
    <CardRoot onClick={handleOpen}>
      <ImageWrapper>
        <CardImage
          id={imageId}
          alt={imageAlt}
          fit="center"
          objectFit="cover"
        />
      </ImageWrapper>
      <ContentArea>{children}</ContentArea>
    </CardRoot>
  )
}

export default CruiseItineraryAttractionCard
